export const orderStatuses = {
  created: 'created',
  preparing: 'preparing',
  delivering: 'delivering',
  completed: 'completed',
  rejected: 'rejected',
};

export const reservationStatuses = {
  pending: 'pending',
  declined: 'declined',
  confirmed: 'confirmed',
  visited: 'visited',
  notVisited: 'not_visited',
  canceled: 'canceled',
};

export const OrderTypes = {
  delivery: 'delivery',
  booking: 'booking',
  takeaway: 'takeaway',
  reservation: 'reservation',
  on_table: 'on_table',
};

export const OrderFilters = {
  all: 'all',
  ...OrderTypes,
};

export const ReservationFilters = {
  day: {
    key: 'day',
    label: 'Giorno',
  },
  service: {
    key: 'service',
    label: 'Servizio',
  },
  timeSlot: {
    key: 'time_slot',
    label: 'Fascia oraria',
  },
  room: {
    key: 'room',
    label: 'Sala',
  },
  all: {
    key: 'all',
    label: 'Prossime',
  },
};
